import projectsApi from '@/api/v1/projects';
import utils from '@/helpers/utils';

const metrics = {
  id: null,
  name: null,
  createdAt: null,
  endDate: null,
  deadline: null,
  projectType: null,
  status: null,
  discLocation: null,
  copy: '',
  templateId: null,
  tags: [],
  campaigns: [],
  members: [],
  orderers: [],
  history: {
    total: null,
    changes: [],
  },
  chat: {
    total: null,
    messages: [],
  },
  thumbnail: {
    id: null,
    filename: null,
    url: null,
  },
  files: [],
  description: '',
  thirdPartyWorks: [],
};

export default {
  namespaced: true,
  state: {
    metrics,
    isFormProcessing: false,
  },

  mutations: {
    SET_METRICS(state, metricsData) {
      state.metrics = metricsData;
    },

    EDIT_THIRD_PARTY_WORK(state, thirdPartyWorksData) {
      state.metrics.thirdPartyWorks = state.metrics.thirdPartyWorks.map(
        (tpw) => {
          const {
            title, author, info, id,
          } = thirdPartyWorksData;
          if (tpw.id === id) {
            return {
              title, author, info, id,
            };
          }
          return tpw;
        },
      );
    },

    CHANGE_METRICS_PROCESSING_STATUS(state, status) {
      state.isFormProcessing = status;
    },

    CLEAR_METRICS_DATA(state) {
      state.metrics = metrics;
    },

  },

  actions: {
    fetchMetrics({ commit, dispatch }, projectId) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      projectsApi.projects.showMetrics(projectId)
        .then((response) => {
          commit('SET_METRICS', response.data);
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    selectActiveThirdPartyWork({ commit }, id) {
      commit('SET_ACTIVE_THIRD_PARTY_WORK', id);
    },

    removeThirdPartyWorks({ commit, dispatch, state }, thirdPartyWorksId) {
      commit('CHANGE_METRICS_PROCESSING_STATUS', true);

      projectsApi.thirdPartyWorks.delete(thirdPartyWorksId)
        .then(() => {
          dispatch('fetchMetrics', state.metrics.id);
          dispatch('snackbar/showSnackbar', {
            message: ['Usunięto utwór'],
            type: 'success',
          }, { root: true });
        })
        .finally(() => {
          commit('CHANGE_METRICS_PROCESSING_STATUS', false);
        });
    },

    addThirdPartyWorks({ commit, dispatch, state }, thirdPartyWorksData) {
      const { id } = state.metrics;
      commit('CHANGE_METRICS_PROCESSING_STATUS', true);

      projectsApi.thirdPartyWorks.create(id, thirdPartyWorksData)
        .then(() => {
          dispatch('fetchMetrics', id);

          dispatch('snackbar/showSnackbar', {
            message: ['Dodano utwór'],
            type: 'success',
          }, { root: true });

          commit('dialog/CLEAR_DIALOG', null, { root: true });
        })
        .finally(() => {
          commit('CHANGE_METRICS_PROCESSING_STATUS', false);
        });
    },

    editThirdPartyWorks({ commit, dispatch }, thirdPartyWorksData) {
      commit('CHANGE_METRICS_PROCESSING_STATUS', true);
      const { id, ...editedData } = thirdPartyWorksData;
      projectsApi.thirdPartyWorks.update(id, editedData)
        .then(() => {
          commit('EDIT_THIRD_PARTY_WORK', thirdPartyWorksData);

          dispatch('snackbar/showSnackbar', {
            message: ['Zapisano zmiany w utworze'],
            type: 'success',
          }, { root: true });

          commit('dialog/CLEAR_DIALOG', null, { root: true });
        })
        .finally(() => {
          commit('CHANGE_METRICS_PROCESSING_STATUS', false);
        });
    },

    clearMetricsObject({ commit }) {
      commit('CLEAR_METRICS_DATA');
    },
  },

  getters: {
    getThirdPartyWorksSingle(state) {
      return (id) => state.metrics.thirdPartyWorks.find(
        (thirdPartyWorks) => thirdPartyWorks.id === id,
      );
    },

    getThirdPartyWorksItems(state) {
      return state.metrics.thirdPartyWorks.map((e) => ({
          ...e,
          info: utils.textExcerpt(e.info),
        }));
    },
  },
};
